import type { PageHelp } from '../network-help.data';

export const L10N_ar_g2: Record<string, PageHelp> = {
  'agency-onboarding': {
    title: 'إدراج وكالة',
    tag: 'معالج',
    tagline: 'إدخال نشاط سفر جديد إلى الشبكة بشكل متوافق مع الضوابط.',
    business: {
      lead: 'الإدراج هو الباب الأمامي المُحكم للدخول إلى الشبكة. قبل أن تتمكن وكالة جديدة من تحريك الأموال أو إصدار التذاكر، يجب أن تعرف المنصة هويتها، وتتحقق منها، وتتفق معها على الشروط التجارية — وهنا تُنشأ هذه العلاقة.',
      points: [
        { title: 'الامتثال قبل التداول', desc: 'تُجرى عمليات التحقق من الهوية والوضع المالي (KYC) في البداية لأن المنصة تمنح الائتمان والتسوية لطرف مقابل جديد.' },
        { title: 'الشروط تحدد العلاقة', desc: 'يُتفق هنا على المستوى وملف هامش الربح والوصول إلى المنتجات — فهي التي تحدد كيفية تداول الوكالة منذ اليوم الأول.' },
        { title: 'سرعة الوصول إلى أول عملية بيع', desc: 'الإدراج النظيف يجعل الشريك المُدرّ للإيرادات جاهزاً للعمل ضمن اتفاقية مستوى خدمة الإدراج.' },
      ],
    },
    software: {
      lead: 'نموذج موجّه متعدد الخطوات يجمّع سجل الوكالة ويوجّهه للموافقة.',
      points: [
        { title: 'التنقل عبر السجل', desc: 'الشركة ← جهات الاتصال ← مستندات KYC ← الإعداد المالي ← المنتجات والوصول ← المستوى وهامش الربح ← المراجعة.' },
        { title: 'الإرسال إلى قائمة الانتظار', desc: 'إكمال المعالج يُدرِج الطلب في قائمة مراجعة KYC بدلاً من تفعيله فوراً.' },
        { title: 'كل شيء في مكان واحد', desc: 'تُجمع جهات الاتصال والمستندات والشروط التجارية معاً حتى تتوفر للمراجعين الصورة الكاملة.' },
      ],
    },
    related: ['agency-kyc', 'contract-templates', 'agencies'],
  },

  'agency-kyc': {
    title: 'قائمة مراجعة KYC',
    tag: 'الامتثال',
    tagline: 'البوابة التي تمر بها كل وكالة جديدة قبل أن تتمكن من التداول.',
    business: {
      lead: 'KYC — اعرف عميلك — هو الالتزام بالتحقق من هوية النشاط التجاري قبل السماح له بالتعامل مع الأموال على المنصة. هذه القائمة هي نقطة التفتيش التي تحمي الشبكة من الاحتيال والتعرض للديون المعدومة.',
      points: [
        { title: 'متطلب وليس إجراءً شكلياً', desc: 'يجب على المنصة التحقق من الأطراف المقابلة قبل منح المحافظ أو الائتمان.' },
        { title: 'المخاطر مرئية', desc: 'يحمل كل طلب مؤشر مخاطرة حتى يقضي المراجعون وقتهم حيث يكون التعرض أعلى.' },
        { title: 'اتفاقية مستوى الخدمة وعد', desc: 'تصفية الطلبات بسرعة تحافظ على سرعة الإدراج دون تخطي عملية التحقق.' },
      ],
    },
    software: {
      lead: 'قائمة فرز للطلبات المعلّقة، لكل منها مسار مستندات للموافقة أو الرفض.',
      points: [
        { title: 'العمل على القائمة', desc: 'قائمة الطلبات مع مرحلتها؛ افتح أحدها لمراجعة المستندات المُقدّمة.' },
        { title: 'تتبع المسار', desc: 'عرض تقدّم مرحلي يُظهر موضع كل طلب وما تبقّى قبل اتخاذ القرار.' },
        { title: 'اتخاذ القرار', desc: 'الموافقة لإطلاق الوكالة في التداول الفعلي (مع توليد اتفاقيتها الرئيسية تلقائياً)، أو الرفض مع ذكر السبب.' },
      ],
    },
    related: ['agency-onboarding', 'contract-templates', 'agencies'],
  },

  'agency-profile': {
    title: 'ملف الوكالة',
    tag: 'سجل',
    tagline: 'العلاقة التجارية والامتثالية الكاملة لوكالة واحدة.',
    business: {
      lead: 'الملف هو الصورة الكاملة لعلاقة تداول واحدة — مكانتها، وأموالها، والشروط التي تعمل بموجبها. إنه ما تفتحه لفهم أو تعديل كيفية تعامل وكالة معينة مع المنصة.',
      points: [
        { title: 'الشروط تعيش هنا', desc: 'المستوى ووراثة هامش الربح والوصول إلى المنتجات تحدد اقتصاديات هذه الوكالة وتُدار على هذا السجل.' },
        { title: 'المكانة في لمحة', desc: 'المحفظة والائتمان وحالة KYC تخبرك فوراً إن كانت الوكالة قادرة على التداول الآن.' },
        { title: 'الوراثة أو التجاوز', desc: 'يمكن للوكالة أن تتبع القيم الافتراضية لمستواها، أو أن تحمل تجاوزات مخصصة تم التفاوض عليها لها تحديداً.' },
      ],
    },
    software: {
      lead: 'سطح تفصيلي لكل وكالة يجمع الهوية والأموال والإعدادات في عرض واحد.',
      points: [
        { title: 'إدارة الأصول والوصول', desc: 'SIGN وقنوات البيع والفروع والأدوار والوصول إلى المنتجات لهذه الوكالة يمكن الوصول إليها من هنا.' },
        { title: 'عضويات المجموعات', desc: 'تظهر عضويات مجموعات التسعير للوكالة كشريط رقاقات وتُغذّي القواعد المحددة بنطاق المجموعة.' },
        { title: 'عرض ذاتي مقابل عرض المشرف', desc: 'ترى الوكالة ملفها الخاص للقراءة غالباً؛ بينما يستطيع المشرف تعديل الشروط واتخاذ الإجراءات.' },
      ],
    },
    related: ['agencies', 'markup', 'branches', 'signs'],
  },

  'contract-templates': {
    title: 'قوالب العقود',
    tag: 'اتفاقيات',
    tagline: 'قوالب الشروط التي تُولَّد منها الاتفاقية الرئيسية.',
    business: {
      lead: 'تتداول كل وكالة بموجب اتفاقية رئيسية. قوالب العقود هي الشروط ذات الإصدارات التي تُولَّد منها تلك الاتفاقيات — بحيث تكون العلاقة القانونية متسقة وحديثة وقابلة للتدقيق عبر الشبكة بأكملها.',
      points: [
        { title: 'مصدر واحد للشروط', desc: 'توليد عقد وكالة يستمد من هذا الكتالوج، فيوقّع الجميع على نفس الشروط الحديثة.' },
        { title: 'ذات إصدارات وقابلة للتدقيق', desc: 'الإصدارات الجديدة تحلّ محل القديمة؛ وتبقى الإصدارات المتقاعدة متاحة لتجديد العقود الأقدم.' },
        { title: 'تغذّي دورة الحياة', desc: 'القالب هو المُدخل لتدفق الاتفاقية توليد ← إرسال ← توقيع ← توقيع مقابل ← تفعيل.' },
      ],
    },
    software: {
      lead: 'كتالوج إصدارات القوالب الذي يقرأ منه نموذج التوليد.',
      points: [
        { title: 'إضافة إصدار', desc: 'أنشئ إصدار قالب جديد وارفع مستنده المصدري.' },
        { title: 'التقاعد لا الحذف', desc: 'قاعِد الإصدارات المستبدَلة؛ تبقى قابلة للاستدعاء للعقود القائمة عليها بالفعل.' },
        { title: 'مصدر المُنتقي', desc: 'مُنتقي القالب في نموذج توليد العقد يقرأ من هذا الكتالوج.' },
      ],
    },
    related: ['agency-onboarding', 'agency-kyc', 'agencies'],
  },

  'reference-data': {
    title: 'البيانات المرجعية',
    tag: 'المفردات الرئيسية',
    tagline: 'قوائم البحث المعيارية التي يُبنى منها كل حجز وقسيمة وسعر.',
    business: {
      lead: 'البيانات المرجعية هي مصدر الحقيقة المشترك — شركات الطيران والمطارات والمدن والعملات وأنواع الغرف ودرجات المقصورة وعشرات غيرها. توحيدها مرة واحدة يعني أن نتائج البحث والتذاكر والقسائم وقواعد التسعير تتحدث جميعها اللغة نفسها عبر المورّدين والخدمات.',
      points: [
        { title: 'الاتساق عبر المنصة', desc: 'قائمة منسّقة واحدة تُغذّي كل خدمة، فتُطابَق رموز المورّد مع نفس المدخل المعياري في كل مكان.' },
        { title: 'غيّر مرة واحدة، طبّق في كل مكان', desc: 'تعديل صف مرجعي يحدّثه في البحث والحجز والمستندات والتقارير دفعة واحدة.' },
        { title: 'محكومة لا نص حر', desc: 'المفردات المضبوطة تُبقي البيانات غير النظيفة خارج التسعير وربط القنوات.' },
      ],
    },
    software: {
      lead: 'سطح إدارة مبني على المخطط لنحو 35 فئة مرجعية مجمّعة حسب المجال.',
      points: [
        { title: 'التصفح والتحرير حسب الفئة', desc: 'اختر فئة، وابحث في صفوفها، وأضف / حرّر / فعّل-عطّل المدخلات؛ بعضها محدد بتاريخ سريان (العملات والضرائب وأسعار الصرف).' },
        { title: 'وصول دقيق التفصيل', desc: 'يُمنح العرض / الإضافة / التحرير / الحالة لكل فئة عبر الأدوار والوصول — والأزرار هنا تعكس ما يسمح به دورك.' },
        { title: 'معياري مقابل قابل للتحرير', desc: 'بعض القوائم (الدول والمناطق الزمنية) معيارية وتُدار مركزياً، ولا تُنشأ عند الطلب.' },
      ],
    },
    related: ['rbac', 'data-simulator'],
  },

  'data-simulator': {
    title: 'محاكي البيانات',
    tag: 'بيانات اصطناعية',
    tagline: 'توليد حجوزات واقعية لتشغيل المنصة دون طلبات حقيقية.',
    business: {
      lead: 'يُصنّع المحاكي طلباً قابلاً للتصديق — حجوزات عبر المنتجات والوكالات والتواريخ — بحيث يمكن عرض واختبار ضغط لوحات المعلومات والتقارير والتسعير والتسوية قبل التداول الحقيقي أو بجانبه.',
      points: [
        { title: 'إثبات المنصة', desc: 'النظام المملوء يُظهر لأصحاب المصلحة كيف تتصرف التقارير وتدفقات الأموال عند الحجم الكبير.' },
        { title: 'آمن للتراجع', desc: 'تُوسم الطلبات المولّدة بحيث يمكن التراجع عن دفعة كاملة بشكل نظيف.' },
        { title: 'سيناريوهات موجّهة', desc: 'وجّه دفعة نحو وكالات أو منتجات محددة لنمذجة شريحة معينة من النشاط.' },
      ],
    },
    software: {
      lead: 'مولّد دفعات يحقن طلبات حقيقية موسومة في محرك الحجز.',
      points: [
        { title: 'إعداد دفعة', desc: 'اختر الحجم ومزيج المنتجات والوكالات ونطاق التاريخ، ثم انشر.' },
        { title: 'طلبات حقيقية، مُعلَّمة', desc: 'العناصر المنشورة هي طلبات حقيقية من خدمة الحجز موسومة بـ “محاكاة”، فتظهر في جميع الحجوزات.' },
        { title: 'التراجع عن الدفعة كاملة', desc: 'أزِل دفعة بإجراء واحد لإعادة النظام إلى حالته السابقة.' },
      ],
    },
    related: ['reference-data', 'rbac'],
  },

  rbac: {
    title: 'الأدوار والوصول',
    tag: 'RBAC',
    tagline: 'تركيب أذونات دقيقة التفصيل في الأدوار التي يحملها موظفوك.',
    business: {
      lead: 'الوصول محكوم بالأذونات لا بالمسميات الوظيفية. الأدوار والوصول هي المكان الذي تجمّع فيه رموز الأذونات الذرّية في أدوار وتمنحها — بحيث يستطيع كل شخص أن يفعل بالضبط ما ينبغي له لا أكثر، سواء كان موظف منصة أو مستخدم وكالة.',
      points: [
        { title: 'أقل امتياز', desc: 'منح أذونات ضيّقة يحدّ من نطاق الضرر إذا أُسيء استخدام حساب.' },
        { title: 'نطاقان', desc: 'أدوار المنصة تعمل عبر الشبكة؛ وأدوار الوكالة محصورة في مستأجرها الخاص.' },
        { title: 'آمن ضد الإقفال', desc: 'أدوار النظام المختومة (مثل مشرف المنصة) تُبقي أذوناتها مقفلة حتى لا يستطيع أحد تجريد وصوله الخاص.' },
      ],
    },
    software: {
      lead: 'الأدوار والمستخدمون وكتالوج أذونات حيّ في مكان واحد.',
      points: [
        { title: 'بناء دور', desc: 'أشّر على رموز الأذونات المجمّعة حسب الوحدة؛ الدور ليس سوى المجموعة التي تختارها.' },
        { title: 'مصفوفة البيانات المرجعية', desc: 'تُمنح أذونات البيانات المرجعية لكل فئة × إجراء (عرض/إضافة/تحرير/حالة)؛ وتحصل أدوار الوكالة على العرض فقط.' },
        { title: 'الإسناد إلى المستخدمين', desc: 'تبويب المستخدمين يربط الأدوار بالأشخاص، محددة بنطاق المنصة أو وكالة معينة.' },
      ],
    },
    related: ['users', 'reference-data', 'settings'],
  },

  users: {
    title: 'المستخدمون',
    tag: 'الحسابات',
    tagline: 'الأشخاص الذين يمكنهم تسجيل الدخول، والأدوار التي يحملونها.',
    business: {
      lead: 'المستخدمون هم الأفراد الذين يشغّلون المنصة — موظفو المنصة وموظفو الوكالات. إدارتهم هنا هي كيف تتحكم بمن يملك الوصول، وتحافظ عليه محدّثاً مع انضمام الأشخاص ومغادرتهم، وتربط كل إجراء بحساب مسؤول.',
      points: [
        { title: 'الوصول يتبع التوظيف', desc: 'تزويد الحسابات وتعطيلها بسرعة هو خط الدفاع الأول للأمان.' },
        { title: 'الأدوار تحمل الصلاحية', desc: 'المستخدم لا يفعل شيئاً بذاته — أدواره هي التي تقرر ما يستطيع فعله.' },
        { title: 'المساءلة', desc: 'تُنسب الإجراءات إلى حساب باسم معلوم، وهو ما يهم في التدقيق والنزاعات.' },
      ],
    },
    software: {
      lead: 'دليل الحسابات مع أدوارها وحالتها.',
      points: [
        { title: 'التزويد والإسناد', desc: 'أنشئ مستخدماً وأسند إليه دوراً أو أكثر، محدداً بنطاق المنصة أو وكالة.' },
        { title: 'تفعيل / تعطيل', desc: 'عطّل الوصول دون حذف السجل عندما يغادر أحدهم.' },
        { title: 'واعٍ بالنطاق', desc: 'يدير المشرفون جميع المستخدمين؛ بينما يدير مشرف الوكالة موظفيه فقط.' },
      ],
    },
    related: ['rbac', 'settings'],
  },

  settings: {
    title: 'الإعدادات',
    tag: 'التهيئة',
    tagline: 'تهيئة على مستوى المنصة والوكالة في مكان واحد.',
    business: {
      lead: 'تحمل الإعدادات المفاتيح التي تشكّل كيف تظهر المنصة وتتصرف — العلامة التجارية والإشعارات والتكاملات والتهيئة الافتراضية. ضبطها بشكل صحيح يُبقي التجربة متسقة والبنية موصولة.',
      points: [
        { title: 'الهوية والتجربة', desc: 'العلامة التجارية والقيم الافتراضية تحدد كيف يبدو ويتصرف الكونسول لمستخدميك.' },
        { title: 'ابقَ موصولاً', desc: 'إعدادات التكامل والإشعارات تُبقي المنصة تتحدث مع العالم الخارجي.' },
        { title: 'ملكية محددة النطاق', desc: 'يدير مشرفو المنصة الإعدادات على مستوى المنصة؛ ويدير مشرفو الوكالة نطاقهم الخاص.' },
      ],
    },
    software: {
      lead: 'لوحات تهيئة مجمّعة للعلامة التجارية والإشعارات والتكاملات والقيم الافتراضية للوكالة.',
      points: [
        { title: 'التحرير حسب القسم', desc: 'اعمل عبر اللوحات المجمّعة واحفظ المجالات التي تديرها.' },
        { title: 'محكوم بالأذونات', desc: 'يتطلب الوصول إذن إدارة الإعدادات؛ ويبقى مدخل الشريط الجانبي متسقاً مع بقية النظام.' },
        { title: 'المنصة مقابل الوكالة', desc: 'ما يمكنك تغييره يعتمد على ما إذا كنت تحمل نطاق المنصة أو الوكالة.' },
      ],
    },
    related: ['rbac', 'users'],
  },

  issues: {
    title: 'متتبّع المشكلات',
    tag: 'ضمان الجودة الداخلي',
    tagline: 'متتبّع العيوب الداخلي للإبلاغ عن مشكلات المنتج وفرزها.',
    business: {
      lead: 'متتبّع المشكلات هو كيف تُلتقط المشكلات الموجودة في الكونسول وتُفرز وتُصلح — حلقة تغذية راجعة هندسية خاصة منفصلة عن تذاكر دعم العملاء، بحيث تتحسن الجودة دون أن تصل الضوضاء إلى الوكالات.',
      points: [
        { title: 'إغلاق الحلقة', desc: 'بلاغ منظّم مع سياق يحوّل “إنه معطّل” إلى شيء يستطيع المهندس التصرف بناءً عليه.' },
        { title: 'ليس دعم العملاء', desc: 'هذا ضمان جودة داخلي — متميز عن تذاكر الدعم الموجّهة للوكالات.' },
        { title: 'أدلة مرفقة', desc: 'لقطات الشاشة وسياق البيئة يجعلان المشكلات قابلة لإعادة الإنتاج.' },
      ],
    },
    software: {
      lead: 'قائمة فرز للمشكلات المُبلَّغ عنها مع لقطات وحالة.',
      points: [
        { title: 'الإبلاغ من أي مكان', desc: 'التقط مشكلة (مع لقطة) من أي مكان عبر اختصار المُبلِّغ، ثم تتبّعها هنا.' },
        { title: 'الفرز والحالة', desc: 'اعمل على القائمة — أسنِد ورتّب الأولويات وانقل المشكلات عبر دورة حياتها.' },
        { title: 'محدد بنطاق المطوّر', desc: 'الفرز الكامل محصور بدور المطوّر، حتى لا يزحم المتتبّع عرض كل مشرف.' },
      ],
    },
    related: ['my-issues'],
  },

  'my-issues': {
    title: 'مشكلاتي المُبلَّغ عنها',
    tag: 'بلاغاتي',
    tagline: 'المشكلات التي رفعتها بنفسك، وموضع كل واحدة منها.',
    business: {
      lead: 'هذه شريحتك الخاصة من متتبّع المشكلات — البلاغات التي قدّمتها وتقدّمها. إنها تُغلق حلقة التغذية الراجعة للمُبلِّغ: يمكنك أن ترى أن ما رفعته قد رُئي وأنه يتحرك.',
      points: [
        { title: 'الوضوح للمُبلِّغين', desc: 'معرفة أن البلاغ استُلم ويتقدّم يشجّع الناس على مواصلة الإبلاغ عن المشكلات.' },
        { title: 'سياقك أنت', desc: 'فقط المشكلات التي رفعتها، حتى تبقى القائمة ذات صلة شخصية بك.' },
        { title: 'المتابعة حتى الحل', desc: 'تتبّع كل بلاغ من الفتح حتى الحل.' },
      ],
    },
    software: {
      lead: 'عرض مُرشّح لمتتبّع المشكلات محدد بنطاق بلاغاتك الخاصة.',
      points: [
        { title: 'شاهد بلاغاتك', desc: 'كل مشكلة قدّمتها، مع حالتها الحالية.' },
        { title: 'افتح للتفصيل', desc: 'تعمّق في بلاغ لرؤية سلسلته ولقطته وتحديثاته.' },
        { title: 'ارفع المزيد', desc: 'قدّم مشكلات جديدة من اختصار المُبلِّغ؛ فتظهر هنا.' },
      ],
    },
    related: ['issues'],
  },

  'supply-properties': {
    title: 'المنشآت الفندقية',
    tag: 'مخزون خاص',
    tagline: 'دليلك للفنادق المتعاقد معها مباشرة — الغرف التي تملكها وتبيعها بنفسك.',
    business: {
      lead: 'هذه فنادق تتعاقد معها مباشرة، على عكس الأسعار التي تعيد بيعها من محركات فنادق خارجية. ولأن المخزون ملكك، فأنت من يحدد الغرف والأسعار الليلية والإتاحة — وتحتفظ بالهامش كاملاً بدلاً من هامش بنك الأسرّة.',
      points: [
        { title: 'مخزون خاص مقابل مُعاد بيعه', desc: 'المنشآت الخاصة تقف جنباً إلى جنب مع نتائج محركات الفنادق الخارجية في البحث والحجز؛ وهنا تتحكم بالسعر والإتاحة من البداية إلى النهاية.' },
        { title: 'النطاق يحدد المدى', desc: 'المنشأة ذات نطاق المنصة تصبح مخزوناً مشتركاً يمكن لأي وكالة بيعه؛ بينما تبقى ذات نطاق الوكالة خاصة بتلك الوكالة.' },
        { title: 'وضع البيع في لمحة', desc: 'كل منشأة إما فورية (تؤكد على الفور) أو عند الطلب (حجز يؤكده المشغّل) — والبطاقة تُشير إلى أيهما.' },
      ],
    },
    software: {
      lead: 'شبكة قابلة للبحث والترشيح لمنشآتك مع حالة سريعة.',
      points: [
        { title: 'العثور على منشأة', desc: 'ابحث بالاسم أو المدينة ورشّح حسب النطاق أو وضع البيع أو الحالة.' },
        { title: 'إدراج منشأة جديدة', desc: 'أنشئ من الصفر، أو انطلق من فندق مرجعي، عبر درج الإدراج.' },
        { title: 'افتح للإدارة', desc: 'انقر للوصول إلى سجل المنشأة لإدارة غرفها وأسعارها وحصتها وخدماتها الإضافية وعقدها.' },
      ],
    },
    related: ['supply-property-detail', 'reference-data'],
  },

  'supply-property-detail': {
    title: 'المنشأة الفندقية',
    tag: 'سجل المنشأة',
    tagline: 'السجل الكامل لمنشأة واحدة — الغرف والأسعار والإتاحة والإضافات والعقد وراءها.',
    business: {
      lead: 'المنشأة الفندقية هي قطعة من المخزون تملكها وتبيعها مباشرة. كل ما يحتاجه الحجز يعيش هنا: ما الغرف الموجودة، وكم تكلّف كل ليلة، وكم منها متاح، وما الإضافات التي يمكن ضمّها، والعقد الذي يحكمها. اضبط هذا بشكل صحيح وتكون المنشأة جاهزة للبيع عبر كونسول B2B و B2C معاً.',
      points: [
        { title: 'مخزون خاص، هامشك أنت', desc: 'العقد المباشر الذي تحمّله بنفسك لا يحمل هامش بنك الأسرّة — الفارق بين السعر الصافي وسعر البيع ملكك بالكامل.' },
        { title: 'نطاق المنصة مقابل الوكالة', desc: 'نطاق المنصة ينشر المنشأة كمخزون مشترك للوكالات؛ ونطاق الوكالة يُبقيها خاصة. الصفوف المملوكة للمنصة تكون للقراءة فقط بالنسبة للوكالة.' },
        { title: 'فوري مقابل عند الطلب', desc: 'الفوري يؤكد على الفور مقابل الحصة؛ وعند الطلب يلتقط الحجز كطلب يؤكده المشغّل أو يرفضه ضمن اتفاقية مستوى خدمة (يُصرَّح بالدفع، ويُحصَّل عند التأكيد).' },
        { title: 'الإتاحة تحميك', desc: 'الحصة هي عدد الغرف المتعاقد عليه؛ يُخصم منها المحجوزات المعلّقة والمباعة حتى لا يتجاوز البيع الفوري المتاح أبداً.' },
      ],
    },
    software: {
      lead: 'مساحة عمل ذات تبويبات لمنشأة واحدة — كل تبويب قسم من السجل، مع شارة تُظهر كم يحتوي. أدناه ما يفعله كل تبويب وكيف تعمل عناصره.',
      points: [
        { title: 'نظرة عامة', desc: 'الملخص المقروء أولاً: الموقع والخريطة، وتصنيف النجوم، والسلسلة، وأبرز المرافق، والوصف، ومؤشرات الأداء الحية — الإشغال منذ بداية الشهر و ADR و RevPAR (جميعها محسوبة مقابل إجمالي مخزون غرف المنشأة).' },
        { title: 'الغرف وأنواع الغرف', desc: 'أضف / حرّر كل نوع غرفة: اختر فئة موحّدة من مرجع أنواع الغرف (هذا ما يقود مطابقة البحث وربط القنوات)، واسم عرض موجّه للضيف ورمز قصير، والإشغال الأقصى، والمساحة بالمتر المربع، والمخزون الفعلي الإجمالي — الأخير هو المقسوم عليه وراء إشغال / RevPAR في النظرة العامة.' },
        { title: 'الأسرّة (لكل نوع غرفة)', desc: 'إعداد الأسرّة مؤلِّف لا نص حر: صفوف من العدد × نوع السرير مأخوذة من مرجع أنواع الأسرّة (مثل “سرير ملكي واحد + سرير أريكة واحد”). السلسلة المؤلَّفة هي ما يظهر في نتائج البحث وعلى القسيمة، فتبقى متسقة في كل مكان.' },
        { title: 'المرافق (لكل غرفة ومنشأة)', desc: 'اختيار متعدد مدعوم بالمرجع مجمّع حسب فئة المرافق (يُدار في البيانات المرجعية ← المرافق). اختر من القائمة المضبوطة بدلاً من كتابة نص حر؛ تُخزّن الاختيارات كتسميات عرض فتُعرض بشكل متطابق في كونسول B2B وعلى القسيمة وفي B2C.' },
        { title: 'المعرض', desc: 'ارفع ورتّب صور المنشأة وصور الغرف. هذه هي الصور التي يراها الوكلاء في البحث والحجز ويراها الضيوف على القسيمة؛ الغرفة بلا صورة ترجع إلى معرض المنشأة.' },
        { title: 'خطط الأسعار', desc: 'خطة السعر حزمة قابلة للبيع — غرفة فقط، B&B، غير قابلة للاسترداد، إلخ. تحمل كل منها أسعارها الخاصة ويمكنها تجاوز وضع بيع المنشأة (فوري / عند الطلب). التقويم وأسعار البحث دائماً لكل خطة سعر.' },
        { title: 'الأسعار والتقويم', desc: 'لكل خطة سعر، اضبط السعر الصافي لليلة واحدة، أو نطاق تاريخي، أو موسم كامل بإجراء واحد. تواريخ عطلة نهاية الأسبوع والموسم تحمل إشارات بصرية (رقاقة ملوّنة)، وإيقاف البيع يُغلق تاريخاً دون حذف سعره. قيمة السعر مطلوبة للحفظ — تُرفض المجموعة الفارغة.' },
        { title: 'الحصة والمحجوزات المعلّقة', desc: 'عدد الغرف المتعاقد عليه المتاح يومياً. الشبكة تقسّم كل يوم إلى معلّق (محجوز، الدفع لم يُحصَّل بعد) مقابل مباع (مؤكد) مقابل حرّ للبيع؛ حدّث العدد بالجملة عبر نطاق تاريخي. المبيعات الفورية تخصم منه فوراً؛ ومبيعات عند الطلب لا تمسّه حتى يؤكد المشغّل.' },
        { title: 'الخدمات الإضافية', desc: 'الإضافات التي تبيعها هذه المنشأة — نقل المطار، الإفطار، السبا، تأخير المغادرة — كل منها مصدره مرجع أنواع الخدمات الإضافية مع سعر وأساس احتساب (لكل حجز / لكل ليلة / لكل مسافر). تظهر كإضافات في رسوم الحجز.' },
        { title: 'الحجوزات الحية', desc: 'كل حجز على هذه المنشأة. بالنسبة لإقامات عند الطلب يعيش شريط التأكيد / الرفض هنا: التأكيد يُحصّل الدفع المصرّح به ويثبّت الحصة؛ والرفض يُلغي التصريح — كلاهما ضمن نافذة اتفاقية مستوى خدمة المنشأة.' },
        { title: 'العقد والإعدادات', desc: 'عقد المورّد بالإضافة إلى المفاتيح التشغيلية: وضع البيع (فوري، أو عند الطلب مع ساعات اتفاقية مستوى الخدمة وأيام مهلة الحجز)، ونطاق المنصة مقابل الوكالة، والحالة النشطة للمنشأة.' },
        { title: 'أدوات الإدراج والتحرير والجملة', desc: 'درج إدراج موجّه ينشئ منشأة من الصفر أو انطلاقاً من فندق مرجعي؛ ودرج التحرير يعدّل التفاصيل الأساسية لاحقاً؛ وأدراج الجملة تضبط الأسعار أو الحصة عبر أيام كثيرة دفعة واحدة.' },
      ],
    },
    modes: {
      lead: 'مفتاحان يغيّران كيف تتصرف المنشأة — وضع البيع (يُضبط تحت العقد والإعدادات، وقابل للتجاوز لكل خطة سعر) والنطاق (يُضبط عند إنشاء المنشأة).',
      modes: [
        { name: 'Instant', when: 'حصة حية تثق بها', desc: 'الحجز يؤكد على الفور ويخصم من الحصة؛ ويُحصَّل الدفع في الحال. يُحجب عندما لا تكون هناك غرفة متاحة للتواريخ والإشغال.' },
        { name: 'On-Request', when: 'يجب أن يؤكد الفندق', desc: 'يُؤخذ الحجز كطلب — يُصرَّح بالدفع (لا يُحصَّل) وتبقى الحصة كما هي — ويؤكد المشغّل أو يرفض ضمن اتفاقية مستوى الخدمة. التأكيد يُحصّل الدفع ويثبّت الحصة؛ والرفض يُلغي التصريح.' },
        { name: 'Platform scope', when: 'مخزون مشترك', desc: 'تُنشر المنشأة للوكالات كمخزون قابل للبيع؛ فيرونها للقراءة فقط ويعيدون بيعها بهامش تجزئتهم الخاص.' },
        { name: 'Agency scope', when: 'مخزون خاص', desc: 'المنشأة تخص وكالة واحدة وقابلة للبيع منها فقط.' },
      ],
    },
    examples: [
      {
        title: 'الإتاحة في ليلة (وضع بيع Instant)',
        rows: [
          { label: 'الحصة المتعاقد عليها', value: '10' },
          { label: '− معلّق (بانتظار التحصيل)', value: '3', accent: 'info' },
          { label: '− مباع (مؤكد)', value: '5' },
          { label: 'حرّ للبيع', value: '2', strong: true, accent: 'accent' },
        ],
        note: 'حجوزات On-Request لا تستهلك الحصة حتى يؤكد المشغّل — فهي محكومة بنوع الغرفة، لا بالعدد اليومي.',
      },
      {
        title: 'الأسعار والتقويم — إقامة 3 ليالٍ (Deluxe · Bed & Breakfast)',
        rows: [
          { label: 'الخميس 2 أبريل · صافي يوم عمل', value: '2,200,000' },
          { label: 'الجمعة 3 أبريل · صافي عطلة نهاية الأسبوع', value: '2,600,000', accent: 'info' },
          { label: 'السبت 4 أبريل · صافي عطلة نهاية الأسبوع', value: '2,600,000', accent: 'info' },
          { label: 'المجموع الفرعي للغرفة (3 ليالٍ)', value: '7,400,000', strong: true },
        ],
        note: 'كل ليلة تحمل السعر الصافي المحدد لخطة سعرها؛ إشارات عطلة نهاية الأسبوع/الموسم مساعدات بصرية — السعر هو ما تحدده لذلك التاريخ. ليلة إيقاف البيع تكون غير قابلة للحجز بغض النظر عن السعر.',
      },
      {
        title: 'الخدمات الإضافية على ذلك الحجز (ضيفان، 3 ليالٍ)',
        rows: [
          { label: 'المجموع الفرعي للغرفة', value: '7,400,000' },
          { label: '+ إفطار · لكل مسافر / ليلة · 150,000 × 2 × 3', value: '+900,000', accent: 'success' },
          { label: '+ نقل المطار · لكل حجز', value: '+1,200,000', accent: 'success' },
          { label: 'إجمالي المنشأة (قبل هامش الربح)', value: '9,500,000', strong: true, accent: 'accent' },
        ],
        note: 'أساس احتساب كل خدمة إضافية (لكل حجز / لكل ليلة / لكل مسافر) يقرر كيف يتضاعف. ثم يُطبّق هامش التجزئة من هامش الربح والقواعد فوقه للوصول إلى سعر المسافر.',
      },
    ],
    tabs: {
      overview: {
        title: 'نظرة عامة',
        lead: 'اللقطة المقروءة أولاً للمنشأة — أين هي، وما الذي تقدّمه، وكيف أداؤها الآن.',
        points: [
          { title: 'الهوية والموقع', desc: 'الاسم وتصنيف النجوم والسلسلة والعنوان ودبوس الخريطة — الحقائق التي يتحقق منها الحاجز أولاً.' },
          { title: 'أبرز المرافق والوصف', desc: 'نقاط بيع المنشأة، مأخوذة من المرافق المدعومة بالمرجع والوصف الحر النص.' },
          { title: 'مؤشرات أداء حية', desc: 'الإشغال منذ بداية الشهر و ADR (متوسط السعر اليومي) و RevPAR (الإيراد لكل غرفة متاحة) — جميعها محسوبة مقابل إجمالي مخزون غرف المنشأة، فلا تقرأ بصدق إلا بعد ضبط عدد المخزون لكل نوع غرفة.' },
        ],
        examples: [
          {
            title: 'كيف تُحسب مؤشرات الأداء — 40 غرفة، شهر من 30 يوماً',
            rows: [
              { label: 'ليالي الغرف المتاحة (40 × 30)', value: '1,200' },
              { label: 'ليالي الغرف المباعة', value: '900' },
              { label: 'الإشغال منذ بداية الشهر (900 ÷ 1,200)', value: '75%', accent: 'info', strong: true },
              { label: 'إيراد الغرف', value: '90,000,000' },
              { label: 'ADR (الإيراد ÷ 900 مباعة)', value: '100,000' },
              { label: 'RevPAR (الإيراد ÷ 1,200 متاحة)', value: '75,000', accent: 'success', strong: true },
            ],
            note: 'RevPAR يمزج السعر والإشغال، فينخفض إذا انخفض السعر أو معدل الملء. غياب عدد مخزون نوع غرفة يكسر المقسوم عليه — تُظهر المربعات شرطة حتى يُضبط في تبويب الغرف.',
          },
        ],
      },
      rooms: {
        title: 'الغرف وأنواع الغرف',
        lead: 'حدّد ما يمكن للمنشأة بيعه: كل نوع غرفة، وكيف ينام، وكم منه موجود.',
        points: [
          { title: 'فئة موحّدة', desc: 'اختر نوعاً موحّداً من مرجع أنواع الغرف — هذا ما يقود مطابقة البحث وربط القنوات، لا الاسم الحر النص.' },
          { title: 'اسم العرض والرمز', desc: 'اسم موجّه للضيف (“Deluxe Sea View”) ورمز قصير للمشغّل.' },
          { title: 'الأسرّة — مؤلِّف لا نص حر', desc: 'ابنِ إعداد الأسرّة من صفوف العدد × نوع السرير (مثل “سرير ملكي واحد + سرير أريكة واحد”) مأخوذة من مرجع أنواع الأسرّة؛ السلسلة المؤلَّفة هي ما يظهر في البحث وعلى القسيمة.' },
          { title: 'المرافق', desc: 'اختيار متعدد مدعوم بالمرجع مجمّع حسب الفئة — يُخزَّن كتسميات عرض فيُعرض بشكل متطابق في B2B وعلى القسيمة وفي B2C.' },
          { title: 'المخزون الإجمالي', desc: 'العدد الفعلي لغرف هذا النوع — المقسوم عليه وراء إشغال و RevPAR في النظرة العامة، فيجب ضبطه لتقرأ مؤشرات الأداء بصدق.' },
        ],
      },
      gallery: {
        title: 'المعرض',
        lead: 'الصور التي يراها الوكلاء في البحث والحجز ويراها الضيوف على القسيمة.',
        points: [
          { title: 'صور المنشأة والغرف', desc: 'ارفع على مستوى المنشأة ولكل نوع غرفة؛ رتّبها بحيث تتصدّر أقوى صورة.' },
          { title: 'رجوع معقول', desc: 'نوع غرفة بلا صورة خاصة به يرجع إلى معرض المنشأة، فلا يكون الإدراج بلا صورة أبداً.' },
        ],
      },
      rates: {
        title: 'الأسعار والتقويم',
        lead: 'اضبط السعر الصافي لكل خطة سعر، ليلة واحدة أو موسماً كاملاً في المرة.',
        points: [
          { title: 'خطة السعر حزمة', desc: 'غرفة فقط، Bed & Breakfast، غير قابلة للاسترداد… كل منها تحمل أسعارها الخاصة ويمكنها تجاوز وضع بيع المنشأة. أسعار البحث دائماً لكل خطة سعر.' },
          { title: 'يوم واحد · نطاق · موسم', desc: 'سعّر ليلة واحدة، أو نطاقاً تاريخياً، أو موسماً كاملاً بإجراء واحد. تواريخ عطلة نهاية الأسبوع والموسم تحمل رقاقة ملوّنة فيكون النمط مرئياً.' },
          { title: 'إيقاف البيع لا الحذف', desc: 'إغلاق تاريخ بإيقاف البيع يُبقي سعره لوقت لاحق — قيمة السعر مطلوبة للحفظ، فتُرفض المجموعة الفارغة.' },
        ],
        examples: [
          {
            title: 'من السعر الصافي إلى السعر الذي يراه الشريك',
            rows: [
              { label: 'السعر الصافي الذي تحمّله لليلة', value: '1,200,000' },
              { label: '+ هامش تجزئة 8% (هامش الربح والقواعد)', value: '+96,000', accent: 'success' },
              { label: 'سعر البحث / البيع', value: '1,296,000', strong: true },
            ],
            note: 'أنت تحدد الصافي هنا؛ وسعر البيع هو الصافي زائد ما تضيفه طبقة تسعير Retail. الفارق هو هامشك على المخزون المملوك.',
          },
        ],
      },
      allotment: {
        title: 'الحصة والمحجوزات المعلّقة',
        lead: 'عدد الغرف المتعاقد عليه المتاح يومياً، وكيف يُحجز كل منها.',
        points: [
          { title: 'أربع حالات لكل يوم', desc: 'الحصة هي العدد المتعاقد عليه؛ يتقسّم كل يوم إلى معلّق (محجوز، الدفع لم يُحصَّل بعد)، ومباع (مؤكد)، وحرّ للبيع.' },
          { title: 'الضبط بالجملة', desc: 'اضبط عدد الحصة عبر نطاق تاريخي كامل بإجراء واحد، بنفس طريقة ضبط الأسعار.' },
          { title: 'فوري مقابل عند الطلب', desc: 'المبيعات الفورية تخصم من الحرّ للبيع فوراً فلا تتجاوز المتاح أبداً؛ ومبيعات عند الطلب لا تمسّ الحصة حتى يؤكد المشغّل.' },
        ],
        examples: [
          {
            title: 'إتاحة يوم واحد',
            rows: [
              { label: 'الحصة المتعاقد عليها', value: '20' },
              { label: '− معلّق (بانتظار التحصيل)', value: '−3' },
              { label: '− مباع (مؤكد)', value: '−5' },
              { label: 'حرّ للبيع', value: '12', accent: 'success', strong: true },
            ],
            note: 'حجز Instant ينقل غرفة من الحرّ ← المباع فوراً؛ وحجز On-Request يترك الأرقام الأربعة كما هي حتى يؤكده المشغّل في تبويب الحجوزات الحية.',
          },
        ],
      },
      ancillaries: {
        title: 'الخدمات الإضافية',
        lead: 'الإضافات التي تبيعها هذه المنشأة إلى جانب الغرفة — النقل، الإفطار، السبا، تأخير المغادرة.',
        points: [
          { title: 'من المرجع', desc: 'فئة كل إضافة تأتي من مرجع أنواع الخدمات الإضافية؛ وأنت تحدد سعراً وأساس احتساب.' },
          { title: 'أساس الاحتساب يضاعف', desc: 'لكل حجز (مرة واحدة)، لكل ليلة (× الليالي)، أو لكل مسافر (× الضيوف) — الأساس يقرر كيف يتوسّع السعر على الحجز.' },
          { title: 'تظهر في الرسوم', desc: 'الإضافات المضافة تظهر في تبويب رسوم الحجز وتنضم إلى سعر المسافر.' },
        ],
        examples: [
          {
            title: 'إضافات على إقامة 3 ليالٍ لضيفين',
            rows: [
              { label: 'نقل المطار · 450,000 لكل حجز', value: '450,000' },
              { label: 'إفطار · 250,000 لكل ليلة × 3', value: '750,000' },
              { label: 'إجمالي الإضافات المضافة إلى الحجز', value: '1,200,000', accent: 'accent', strong: true },
            ],
            note: 'أساس الاحتساب هو ما يجعل نفس سعر القائمة يتوسّع بشكل مختلف — لكل حجز يُحتسب مرة واحدة، ولكل ليلة يتبع طول الإقامة، ولكل مسافر يتبع عدد الأشخاص.',
          },
        ],
      },
      bookings: {
        title: 'الحجوزات الحية',
        lead: 'كل حجز على هذه المنشأة — وحيث تُؤكد إقامات On-Request.',
        points: [
          { title: 'قائمة الحجز الكاملة', desc: 'شاهد من حجز، وأي غرفة وخطة سعر، والتواريخ والحالة.' },
          { title: 'تأكيد / رفض On-Request', desc: 'بالنسبة لإقامات On-Request يعيش شريط القرار هنا: التأكيد يُحصّل الدفع المصرّح به ويثبّت الحصة؛ والرفض يُلغي التصريح.' },
          { title: 'ضمن اتفاقية مستوى الخدمة', desc: 'يجب أن يحدث كلا الإجراءين ضمن نافذة اتفاقية مستوى خدمة On-Request للمنشأة (تُضبط تحت العقد والإعدادات)، وإلا انقضى الطلب.' },
        ],
      },
      settings: {
        title: 'العقد والإعدادات',
        lead: 'عقد المورّد بالإضافة إلى المفاتيح التشغيلية التي تحكم كيف تبيع المنشأة.',
        points: [
          { title: 'شروط العقد', desc: 'الاتفاقية التجارية وراء المنشأة — الأساس للأسعار الصافية التي تحمّلها.' },
          { title: 'وضع البيع', desc: 'Instant، أو On-Request مع ساعات اتفاقية مستوى خدمته وأيام مهلة الحجز. يمكن لخطط الأسعار تجاوز هذا لكل خطة.' },
          { title: 'النطاق والحالة', desc: 'Platform (مشترك للوكالات، للقراءة فقط بالنسبة لها) مقابل Agency (خاص)، بالإضافة إلى حالة المنشأة نشطة / متوقفة.' },
        ],
      },
    },
    related: ['supply-properties', 'reference-data', 'markup'],
  },
};
